var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.status != 'draft')?_c('UrlContent',{attrs:{"item":_vm.item,"header":_vm.header}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }